/* istanbul ignore file */
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Grid, Paper, PaperProps } from '@mui/material';

import HighlightAsterisks from 'src/components/HighlightAsterisks/HighlightAsterisks';

interface AllowancePaperProps extends PaperProps {
  disabled: boolean;
}

export const AllowancePaddedPaper = (props: AllowancePaperProps) => {
  const { title, disabled } = props;

  return (
    <Paper
      {...props}
      sx={{
        padding: '20px',
        boxShadow: 'none',
        border: '1px solid',
        borderColor: '#DCDCDC',
        borderRadius: '8px'
      }}
    >
      <Grid container spacing={2}>
        {props.title && (
          <Grid item xs={12}>
            <Typography type="title-md">
              <HighlightAsterisks text={title} disabled={disabled} />
            </Typography>
          </Grid>
        )}
        {props.children}
      </Grid>
    </Paper>
  );
};
